import React from "react";
import { LogoRea, LogoPartners } from "@/components/Logos";

export default function Footer({ settings }) {
  return (
    <footer className="relative border-t border-white/10 bg-[#050505] px-6 py-14 md:px-10" data-testid="footer">
      <div className="mx-auto max-w-7xl">
        <div className="flex items-center justify-between gap-6">
          <LogoPartners src={settings?.logo_partners} size="h-11 md:h-12" />
          <LogoRea src={settings?.logo_rea} size="h-14 md:h-16" />
        </div>

        <div className="mt-8 text-sm text-white/50">
          <p className="font-display font-bold text-white/80">{settings?.org_contact}</p>
          <p className="mt-1">
            <a href={`mailto:${settings?.org_email}`} className="transition-colors hover:text-[#f5c542]">
              {settings?.org_email}
            </a>
          </p>
          <p>{settings?.org_phone}</p>
        </div>

        <div className="speed-line my-8" />

        <div className="flex flex-col items-start justify-between gap-4 text-xs text-white/40 sm:flex-row sm:items-center">
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <a href="#" className="transition-colors hover:text-white">Privacy Policy</a>
            <a href="#" className="transition-colors hover:text-white">Trattamento dei dati</a>
            <a href="#" className="transition-colors hover:text-white">Gestione cookie</a>
          </div>
          <p>© {new Date().getFullYear()} Rea Company Srl. Tutti i diritti riservati.</p>
        </div>
      </div>
    </footer>
  );
}
